export enum PanelType {
  RFQ = 'rfq',
  Info = 'info',
  Diff = 'diff',
  Camera = 'camera',
  Discuss = 'discuss',
}

export const PanelTypes = [PanelType.Info, PanelType.RFQ, PanelType.Diff];

export const MAX_TABLE_WIDTH = 1150;

export enum SystemCategory {
  Quotes = 'Quotes',
  Orders = 'Orders',
  RFQs = 'Requests for Quotation',
}

export const DefaultMenuRoute = 'workspace.spaceProjects';

export const routesWithoutQueryProfileSpace = [
  'home.newInitiative',
  'workspace.upgrade', // profile space need manually update subscription type.
];

export const routesWithoutValidationSpace = [
  'home.newInitiative',
  'workspace.upgrade',
];

export const routesWithoutChatButtons = ['workspace.make-part.file'];

export const MaxDisplayNameSize = 20;

export const MessageType = {
  refreshConflictData: 'refreshConflictData',
};

export enum DataFormatter {
  full = 'dd/MM/yyyy HH:mm:ss',
}
